import { render, staticRenderFns } from "./changePassWord.vue?vue&type=template&id=fa2b77fa&"
import script from "./changePassWord.vue?vue&type=script&lang=js&"
export * from "./changePassWord.vue?vue&type=script&lang=js&"
import style0 from "./changePassWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports